/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface OpenPositionRequest {

    id?: string;

    /**
     * Title of the open position
     */
    position_title?: string;

    /**
     * Industry type of the open position
     */
    industry?: string;

    /**
     * Job duration of the open position
     */
    job_duration?: string;

    /**
     * Job location of the open position
     */
    job_location?: string;

    /**
     * Description summary of the open position
     */
    summary_job_description?: string;

    /**
     * About this open position
     */
    about_tyt?: string;

    /**
     * Full job description of the open position
     */
    job_description?: string;

    /**
     * Primary responsibilities of the open position
     */
    primary_responsibilities?: string;

    /**
     * Requirement info about this open position
     */
    requirements?: string;

    /**
     * Full job description of the open position
     */
    education?: string;

    /**
     * Primary responsibilities of the open position
     */
    related_work_experience?: string;

    /**
     * Requirement info about this open position
     */
    equal_opportunity_employer?: string;

    /**
     * Application info about this open position
     */
    applying?: string;

    /**
     * Option to show open position
     */
    visible?: boolean;

}

@Model('OpenPosition')
export class ApiOpenPosition extends BaseModel implements OpenPositionRequest {

    
    
    id: string;

    /**
     * Title of the open position
     */
    
    
    position_title: string;

    /**
     * Industry type of the open position
     */
    
    
    industry: string;

    /**
     * Job duration of the open position
     */
    
    
    job_duration: string;

    /**
     * Job location of the open position
     */
    
    
    job_location: string;

    /**
     * Description summary of the open position
     */
    
    
    summary_job_description: string;

    /**
     * About this open position
     */
    
    
    about_tyt: string;

    /**
     * Full job description of the open position
     */
    
    
    job_description: string;

    /**
     * Primary responsibilities of the open position
     */
    
    
    primary_responsibilities: string;

    /**
     * Requirement info about this open position
     */
    
    
    requirements: string;

    /**
     * Full job description of the open position
     */
    
    
    education: string;

    /**
     * Primary responsibilities of the open position
     */
    
    
    related_work_experience: string;

    /**
     * Requirement info about this open position
     */
    
    
    equal_opportunity_employer: string;

    /**
     * Application info about this open position
     */
    
    
    applying: string;

    /**
     * Option to show open position
     */
    
    
    visible: boolean;

}
